import React from "react";
import { IconButton, RefreshButton, Box } from "..";
import MoreHorizontal from "@tiny/icons/generated/MoreHorizontal";
import { useStyles } from "./PageHeader.styles";
import { PageHeaderProps } from "./PageHeader.types";
import BackNavigation from "../BackNavigation";
import PageTitle from "../PageTitle/PageTitle";

function PageHeader(props: PageHeaderProps) {
  const {
    actions,
    backUrl,
    extra,
    hideRefresh,
    onMoreMobile,
    mb,
    customBackNavigation,
    ...pageTitleProps
  } = props;

  const classes = useStyles();

  return (
    <Box mb={mb} className={classes.root}>
      <div className={classes.wrap}>
        <BackNavigation backUrl={backUrl} className={classes.back} />
        {customBackNavigation && (
          <div className={classes.back}>{customBackNavigation}</div>
        )}
        <div className={classes.content}>
          <PageTitle {...pageTitleProps} />
        </div>
        {hideRefresh !== true && (
          <div className={classes.refresh}>
            <RefreshButton />
          </div>
        )}
        {onMoreMobile && (
          <div className={classes.more}>
            <IconButton onClick={onMoreMobile} size="small" aria-label="More">
              <MoreHorizontal />
            </IconButton>
          </div>
        )}
        {actions && <div className={classes.actions}>{actions}</div>}
      </div>
      {extra && <div className={classes.extra}>{extra}</div>}
    </Box>
  );
}

export default PageHeader;
